import
{
    IonButton
} from "@ionic/react";

import
{
    FC,
    useRef
} from "react";

import
{
    ExcelWorkBook
} from "../../../Export/Excel";

import
{
    useSystemDocumentation,
    useSystemSpecification
} from "../../../ReactData/system";

import TableForm1 from "./Components/TableForm1";
import TableForm2 from "./Components/TableForm2";
import TableForm3 from "./Components/TableForm3";
import TableZones from "./Components/TableZones";
import TableControls1 from "./Components/TableControls1";
import TableControls3 from "./Components/TableControls3";
import TableInputs from "./Components/TableInputs";
import TableSubmissionNetwork from "./Components/TableSubmissionNetwork";
import Spinner1 from "../../../LoadingScreen/Component/Spinner1/Spinner1";

export type SystemDocumentationProps = {
    systemId?: string;
};

const SystemDocumentation: FC<SystemDocumentationProps> = ({
    systemId
}) =>
{
    const { displaySettings } = useSystemSpecification(systemId || "");
    const structure = useSystemDocumentation(systemId || "");
    const container = useRef<HTMLDivElement>(null);
    if (!structure || Object.keys(structure).length === 0) {
        return (
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                <Spinner1 />
            </div>
        );
    }

    return <div ref={container}>

        <IonButton
            className="noPrint"
            onClick={() =>
            {

                const wb = new ExcelWorkBook('SystemDocumentation');
                const tables = container.current?.querySelectorAll('table') || [];
                for (const table of tables) {
                    const name = table.dataset['name'] || undefined;
                    wb.addSheet(table, name);
                }
                wb.download();

            }}
        >Excel Export</IonButton>

        <TableForm1 data={structure.Form1} />
        <TableForm2 data={structure.Form2} />
        <TableForm3 data={structure.Form3} />
        <TableZones data={structure.ControlGroupDirectory} />
        <TableControls1 data={structure.Controls1} displaySettings={displaySettings!} />
        <TableControls3 data={structure.Controls3} displaySettings={displaySettings!} />
        <TableInputs data={structure.Inputs} />
        <TableSubmissionNetwork data={structure.SubmissionNetwork} />

    </div>;
};

export default SystemDocumentation;
